import { useEffect, useRef, useState } from 'react'

type ReadMoreTruncatedTextProps = {
	text: string
	ctaLabel?: string
}

export default function ReadMoreTruncatedText({
	text,
	ctaLabel = 'Read More'
}: ReadMoreTruncatedTextProps) {
	const [isTruncated, setIsTruncated] = useState(false)

	const textRef = useRef<HTMLParagraphElement>(null)

	// Calculate how manby lines of text there are
	useEffect(() => {
		if (textRef?.current) {
			const lineHeight = getComputedStyle(textRef?.current).getPropertyValue('line-height')

			const numberOfLines = Math.round(textRef.current.clientHeight / parseInt(lineHeight, 10))

			if (numberOfLines > 3) {
				setIsTruncated(true)
			}
		}
	}, [])

	return text ? (
		<div className="relative text-sm font-light">
			<p className={`text-gray-500 ${isTruncated ? 'line-clamp-3' : ''}`} ref={textRef}>
				{text}
			</p>

			{isTruncated && (
				<button
					type="button"
					className="absolute bottom-0 right-0 z-10 bg-white"
					onClick={() => setIsTruncated(false)}
				>
					...<span className="text-bbx-spark">{ctaLabel}</span>
				</button>
			)}
		</div>
	) : null
}
